import { ActionType } from '@root/state/actions-types';
import { Action } from '@root/state/actions/return_disposal';

export type returnDisposalList = {
  key: number;
  id: number;
  name: string;
  productName: string;
  sku: string;
  quantity: number;
  processType: string;
  status: string;
  updatedAt: string;
};

export interface returnDisposalListState {
  loading: boolean;
  error: string | null;
  data: returnDisposalList[] | any;
}

const initialReturnDisposalState: returnDisposalListState = {
  loading: false,
  error: null,
  data: []
};
export const returnDisposalReducer = (
  state: returnDisposalListState = initialReturnDisposalState,
  action: Action
): returnDisposalListState => {
  switch (action.type) {
    case ActionType.GET_RETURN_DISPOSAL_LIST:
      return {
        ...initialReturnDisposalState,
        loading: true,
        error: null,
        data: []
      };
    case ActionType.GET_RETURN_DISPOSAL_LIST_SUCCESS:
      return {
        ...initialReturnDisposalState,
        loading: false,
        error: null,
        data: action.payload
      };
    case ActionType.GET_RETURN_DISPOSAL_LIST_ERROR:
      return {
        ...initialReturnDisposalState,
        loading: false,
        error: action.payload,
        data: []
      };

    default:
      return state;
  }
};

export type productsReturn = {
  id: number;
  productName: string;
  sku: string;
  eanUpc: number;
  quantity: number;
};
export type orderReturn = {
  id: number;
  updatedAt: string;
  status: string;
  orderNumber: string;
  orderDate: string;
  saleChannel: string;
  buyerName: string;
  buyerEmail: string;
  recipientName: string;
  recipientCountryCode: number;
  recipientPhone: number;
  shippingAddress: string;
  detailAddress: string;
  detailAddress2: string;
  lng: number;
  lat: number;
  street: string;
  city: string;
  state: string;
  country: string;
  postalCode: number;
  products: productsReturn[];
  packagingMethod: string;
  dangerous: string;
  shippingMethod: string;
  sellerComment: string;
  courier: string;
  trackingNumber: string;
  warehouseComment: string;
};

export type returnDetail = {
  id: number;
  product: string;
  order: orderReturn;
  import: string;
  status: string;
  returnReason: string;
  recipientName: string;
  recipientPhone: number;
  returnAddress: string;
  importProducts?: {
    products?: orderReturn;
    returnQuantity?: [
      {
        productId: number;
        productName: string;
        returnQuantity: number;
      }
    ];
  };
  lng: number;
  lat: number;
  street: string;
  city: string;
  state: string;
  country: string;
  postalCode: number;
  detailReturnAddress: string;
  detailReturnAddress2: string;
  comment: string;
  returnType: string;
  processType: string;
  quantity: number;
  warehouseUpdateDate: string;
  courier: string;
  trackingNumber: number;
  deliveryStatus: string;
};

export interface ReturnDisposalDetailState {
  detailLoading: boolean;
  error: string | null;
  detailData: returnDetail | any;
}

const initialReturnDetail: returnDetail = {
  id: NaN,
  product: '',
  order: {
    id: NaN,
    updatedAt: '',
    status: '',
    orderNumber: '',
    orderDate: '',
    saleChannel: '',
    buyerName: '',
    buyerEmail: '',
    recipientName: '',
    recipientCountryCode: NaN,
    recipientPhone: NaN,
    shippingAddress: '',
    detailAddress: '',
    detailAddress2: '',
    lng: NaN,
    lat: NaN,
    street: '',
    city: '',
    state: '',
    country: '',
    postalCode: NaN,
    products: [],
    packagingMethod: '',
    dangerous: '',
    shippingMethod: '',
    sellerComment: '',
    courier: '',
    trackingNumber: '',
    warehouseComment: ''
  },
  import: '',
  status: '',
  returnReason: '',
  recipientName: '',
  recipientPhone: NaN,
  returnAddress: '',
  lng: NaN,
  lat: NaN,
  street: '',
  city: '',
  state: '',
  country: '',
  postalCode: NaN,
  detailReturnAddress: '',
  detailReturnAddress2: '',
  comment: '',
  returnType: '',
  processType: '',
  quantity: NaN,
  warehouseUpdateDate: '',
  courier: '',
  trackingNumber: NaN
};
const initialReturnDisposalDetailState: ReturnDisposalDetailState = {
  detailLoading: false,
  error: null,
  detailData: initialReturnDetail
};

// export const returnDisposalDetailReducer //

export const returnDisposalDetailReducer = (
  state: ReturnDisposalDetailState = initialReturnDisposalDetailState,
  action: Action
): ReturnDisposalDetailState => {
  switch (action.type) {
    case ActionType.GET_RETURN_DISPOSAL_DETAIL:
      return {
        ...initialReturnDisposalDetailState,
        detailLoading: true,
        error: null,
        detailData: {}
      };
    case ActionType.GET_RETURN_DISPOSAL_DETAIL_SUCCESS:
      return {
        ...initialReturnDisposalDetailState,
        detailLoading: false,
        error: null,
        detailData: action.payload
      };
    case ActionType.GET_RETURN_DISPOSAL_DETAIL_ERROR:
      return {
        ...initialReturnDisposalDetailState,
        detailLoading: false,
        error: action.payload,
        detailData: {}
      };
    default:
      return state;
  }
};

export type saveBody = {
  updateDate: string;
  status: string;
  courier: string;
  trackingNumber: string;
};
export interface saveBodyState {
  saveLoading: boolean;
  error: string | null;
  saveDate: returnDetail | any;
}

const initialSaveState: saveBodyState = {
  saveLoading: false,
  error: null,
  saveDate: initialReturnDetail
};

export const returnSave = (
  state: saveBodyState = initialSaveState,
  action: Action
): saveBodyState => {
  switch (action.type) {
    case ActionType.PUT_RETURN_DISPOSAL_SAVE:
      return {
        ...initialSaveState,
        saveLoading: true,
        error: null,
        saveDate: {}
      };
    case ActionType.PUT_RETURN_DISPOSAL_SAVE_SUCCESS:
      return {
        ...initialSaveState,
        saveLoading: false,
        error: null,
        saveDate: action.payload
      };

    case ActionType.PUT_RETURN_DISPOSAL_SAVE_ERROR:
      return {
        ...initialSaveState,
        saveLoading: false,
        error: action.payload,
        saveDate: {}
      };
    default:
      return state;
  }
};
